import { Card, CardContent } from '@/components/ui/card'
import type { PipelineActivityTemplate } from '@/services/api/cases'
import { cn } from '@/utils/cn'
import { getPipelineIcon } from './icon-map'
import { type PipelineStage, STAGE_TONE } from './pipeline-stage'

export function PipelineActivityCard({
  activity,
  stage,
}: {
  activity: PipelineActivityTemplate
  stage: PipelineStage
}) {
  const tone = STAGE_TONE[stage]
  const Icon = getPipelineIcon(activity.icon)
  return (
    <Card className={cn('transition-colors', tone.hover)}>
      <CardContent className="pt-4">
        <div className="flex items-start gap-3">
          <div className={cn('p-2 rounded-lg', tone.iconBg)}>
            <Icon className={cn('h-5 w-5', tone.icon)} />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="font-medium text-foreground truncate">{activity.name}</h4>
            <p className="text-xs text-muted-foreground font-mono truncate">{activity.id}</p>
            <p className="text-sm text-muted-foreground mt-2 line-clamp-2">
              {activity.description}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
